<h2 class="comp-title" style="margin-bottom: 25px;">Brand buttons</h2>
<div class="brand-wrapper">
<div class="all-brand-buttons">
   <a href="#" class="brand-button aqua-button" title=""><span>להצטרפות</span></a>
   <a href="#" class="brand-button red-button" title=""><span>להצטרפות</span></a>
   <a href="#" class="brand-button blue-button" title=""><span>להצטרפות</span></a>
   <a href="#" class="brand-button solid-button-black" title=""><span>להצטרפות</span></a>
   <a href="#" class="brand-button solid-button-blue" title=""><span>להצטרפות</span></a>
   <a href="#" class="brand-button aqua-button button-disabled" title=""><span>להצטרפות</span></a>
</div>
<div class="dark-back">
    <a href="#" class="brand-button white-button-blue" title=""><span>להצטרפות</span></a>
    <a href="#" class="brand-button white-button-red" title=""><span>להצטרפות</span></a>
</div>
</div>
